import { useCallback } from 'react'
import ApiService from '../../../services/ApiService'

const InteractorCorrectionSearch = () => {
  const correctionSearch = useCallback((payload, callback, loading) => {
    ApiService.jsonRequest('/transaction-correction-header/search', payload, (response) => {
      if (response.status_code === 200) {
        if (response.data) {
          callback(response.data)
        }
      }
      loading(false)
    })
  }, [])
  return { correctionSearch }
}

export default InteractorCorrectionSearch
